import { get } from 'lodash';

export const getRecipeData = state =>
  get(state, 'CommonState.getRecipe.recipeData');

export const getRecipeError = state =>
  get(state, 'CommonState.getRecipe.error');

export const getRecipeLoading = state =>
  get(state, 'CommonState.getRecipe.loading');



// WEBPACK FOOTER //
// ./src/state/getrecipe/selectors.js